export function createQueryMap(obj: any) {
  return Object.keys(obj).map(key => {
    const value = obj[key]

    if (typeof value !== 'undefined') {
      return [key, value]
    } else {
      return;
    }
  }).filter(qMap => !!qMap);
}
